export const ESTADO_PRESTAMO = {
  PENDIENTE: 1,
  EN_PROGRESO: 2,
  COMPLETADO: 3,
} as const

export type EstadoPrestamoType =
  (typeof ESTADO_PRESTAMO)[keyof typeof ESTADO_PRESTAMO]
